import { render } from "./ManageRegistCount.vue?vue&type=template&id=46148c3f"
import script from "./ManageRegistCount.vue?vue&type=script&lang=js"
export * from "./ManageRegistCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__